import React, { Component } from "react";
import CircularLoadingScreen from "./commons/CircularLoadingScreen";
import SearchWidget from "./commons/SearchWidget";

import SearchResults from "./postsSections/SearchResults";

class Search extends Component {
  getQueryParams = () => {
    return Object.fromEntries(new URLSearchParams(this.props.location.search));
  };

  render() {
    const { q: query, target } = this.getQueryParams();

    return (
      <div>
        <div style={{ padding: "0 20px" }}>
          <h1 className="heading">Search</h1>
          <SearchWidget
            style={{
              marginTop: 10,
            }}
            key={JSON.stringify({ query, target })}
            query={query}
            searchTarget={target}
          />
        </div>
        {!query || query.trim().length == 0 ? (
          <p style={{ padding: "0 20px" }}>Search results will appear here</p>
        ) : (
          <SearchResults
            query={query}
            target={target}
            key={JSON.stringify({ query, target })}
          />
        )}
      </div>
    );
  }
}

export default Search;
